// Paid from savings: a purchase covered by moving money back from a fund of money set aside
// (migration 0037, transactions.funded_from_category_id). It keeps its own category for history,
// counts as paid (its item or same-amount bill too) and is left out of spending: spent, pace,
// history, repeat overage and left to spend. Hush never tracks a fund's balance; the fund's screen
// only tallies what was used this month. Every line of its copy is here.

const dollars = (cents: number) => `$${(cents / 100).toFixed(2)}`;

export const FUND_LABEL = 'Paid from savings';
export const FUND_NONE = 'Not from savings';
/** Under the choice in the edit and add sheets. */
export const fundPaidLine = (fund: string) => `Counts as paid. Not spent, because it came from ${fund}.`;
/** The merchant was paid from this fund last time: one tap, never applied by itself. */
export const fundAgain = (fund: string) => `Paid from ${fund} again?`;
/** The small print on a purchase row: its amount is not in the totals above it. */
export const fundSmallPrint = (fund: string) => `Paid from ${fund}, not spent`;
/** On the fund's own screen: a plain tally of this month's purchases paid from it, not a balance. */
export const fundUsedLine = (cents: number) => `Used this month: ${dollars(cents)}`;

export const FUND_NOT_HERE = 'Only your own spending can be paid from savings.';
export const FUND_UNKNOWN = 'Pick one of your money set aside categories.';
export const FUND_SPREAD = 'A yearly purchase spread over 12 months already counts as monthly shares.';
export const FUND_IN_USE = 'Purchases are paid from it. Change them first.';
